import { selectIsHeaderBannerClosed } from 'store/slices/UI-Slice';
import './styles.scss'
import { useSelector } from 'react-redux';

const ColumnWrapper = ({ SideText, children }) => {
    const isHeaderBannerClosed = useSelector(selectIsHeaderBannerClosed)

    return (
        <div className="inner-container">
            <div className="with-sidetext-layout">
                <div className={`with-sidetext-layout__left ${isHeaderBannerClosed ? "" : "with-sidetext-layout__left--with-banner"}`}>{SideText}</div>
                <div className="with-sidetext-layout__right">{children}</div>
            </div>
        </div>
    )
};

export default ColumnWrapper;